import { FC } from "react";
import {
  InformationBox,
  MuiButtonPrimary,
  MuiGrid,
} from "../../../../../components";
import {
  gridSizeHeader,
  MODULE_PERMISSIONS,
  PAGE_IDS,
} from "../../../../../helpers/constants";
import { usePermissions } from "../../../../../hooks/usePermissions";
import { useSiteCore } from "../../../../../hooks/useSiteCore";
import { coachDashboardHeaderSiteCoreKeys } from "../../../sitecore/SiteCoreKeys";
import { CPDashboardHeaderWrapper } from "./CPDashboardHeader.style";

interface CPDashboardHeaderProps {
  onAddActivityClick?: () => void;
}

const pageId = PAGE_IDS.COACH_PORTAL_DASHBOARD_HEADER;
export const CPDashboardHeader: FC<CPDashboardHeaderProps> = ({
  onAddActivityClick,
}) => {
  const { fetchLabel, pageTitle } = useSiteCore();
  const { hasModulePermission } = usePermissions();
  const { dashboardHeaderTitle, addActivityButton } =
    coachDashboardHeaderSiteCoreKeys;

  return (
    <CPDashboardHeaderWrapper>
      <MuiGrid container>
        <MuiGrid size={gridSizeHeader} className="header-left">
          <InformationBox title={pageTitle} />
        </MuiGrid>
        <MuiGrid size={gridSizeHeader} className="header-right">
          {hasModulePermission(MODULE_PERMISSIONS.COACH_PORTAL_EDIT) && (
            <MuiButtonPrimary
              onClick={onAddActivityClick}
              className="header-right-button"
              id={`${pageId}-addActivity`}
              data-testid={`${pageId}-addActivity`}
            >
              {fetchLabel(dashboardHeaderTitle, addActivityButton)}
            </MuiButtonPrimary>
          )}
        </MuiGrid>
      </MuiGrid>
    </CPDashboardHeaderWrapper>
  );
};
